import * as React from 'react';
import axios from 'axios';
import LogPlusAnyResourcesAutocomplete from './LogPlusAnyResourcesAutocomplete';
import { IPersonListItem } from './IModels';
import LogPlusAutocompleteOption from './LogPlusAutocompleteOption';

interface GetPersonsAutocompleteResult {
	success: boolean,
	status?: "LogDisabled",
	items?: IPersonListItem[]
}

export interface IAutocompleteParams {
	maxRows: number,
	filterId?: string,
}

interface IProps<T> {
	value: T[],
	onSelect: (value: T[]) => void,
	multiple?: true | false,
	placeholderText?: string,

	error?: boolean;
	helperText?: string,
	searchIn: (keyof T)[],
	filterId: string,
}

export default function LogPlusPersonsAutocomplete(props: IProps<IPersonListItem>)
{
	const getOptionSelected = (option: IPersonListItem, value: IPersonListItem) => {
		return option.Id === value.Id;
	}

	return (<LogPlusAnyResourcesAutocomplete
		{...props}
		getOptionLabel={(option: IPersonListItem) => option.Login}
		getOptionSelected={getOptionSelected}
		createRequest={(text: string) => {
			return {
				text: text,
			}
		}}
		loadOptions={(request, callback) => {

			axios.get<GetPersonsAutocompleteResult>('/LogPlusResources/GetPersonsAutocomplete/', {
				params: {
					search: request.text,
					searchIn: props.searchIn?.join(','),
					max: 20,
					filterId: props.filterId,
				}
			})
				.then(r => {
					callback(r.data.items);
				});
		}}
		renderOption={option => <LogPlusAutocompleteOption
			kind={"Person"}
			name={option.Login}
			type={null}

			item={option}
			searchIn={props.searchIn}
		/>}
	/>)
}